import React, { Component } from 'react';
import './style.css';
import { Input, Button } from 'reactstrap';
import * as FontAwesome from 'react-icons/lib/fa'
import { Link } from 'react-router-dom';
import history from './../../../../utils/history';
import Loader from './../../loader/loader';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { sendData } from '../../../../analytics/sendData';
class coffeeCups extends Component {
    constructor(props) {
        super(props)
        this.state = {
            contentLoading: true,
            randomReading: 0,
            cup_no1:false,
            cup_no2:false,
            cup_no3:false,
            cup_no4:false,
            counter:0
        }

    }
    getRandomInt(min, max) {
        return Math.round((Math.random() * (max - min) + min) / 3) * 3;
    }
    componentDidMount() {
        sendData('', 'coffee cup reading', 'viewed');
        window.scrollTo(0, 0);
        setTimeout(() => this.setState({ contentLoading: false }), 1500);
        const randomReading = this.getRandomInt(0, 47);
        this.setState({
            randomReading
        })
    }

    counter=(cupno)=>{
        if(cupno===true){
            this.setState({
                counter:this.state.counter+1
            })
        }else{
            this.setState({
                counter:this.state.counter-1
            })
        }
    }
    handlSelected=(cup_no)=>{
        sendData('', 'coffee cup reading', 'engaged');
        if(cup_no===1){
            this.setState({
                cup_no1:!this.state.cup_no1
            },()=>{
                this.counter(this.state.cup_no1)
            })
        }
        else if(cup_no===2){
            this.setState({
                cup_no2:!this.state.cup_no2
            },()=>{
                this.counter(this.state.cup_no2)
            })
        }
        else if(cup_no===3){
            this.setState({
                cup_no3:!this.state.cup_no3
            },()=>{
                this.counter(this.state.cup_no3)
            })
        }else{
            this.setState({
                cup_no4:!this.state.cup_no4
            },()=>{
                this.counter(this.state.cup_no4)
            })
        }
      
    }
    handleDailyreading = () => {
        sendData('', 'coffee cup reading', 'engaged');
        let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
        let cupAlertMessage;
        if (countryCode.countryCode === 'fr') {
            cupAlertMessage = "Veuillez sélectionner toutes les cartes";
        } if (countryCode.countryCode === 'gr') {
            cupAlertMessage = "Επιλέξτε τουλάχιστον τρία φλυτζάνια.";
        }else{
            cupAlertMessage = "Select minimum three cups.";
        }
        if (this.state.counter>=3) {
            history.push({
                pathname: '/CoffeeReadings',
                state: { reading: this.state.randomReading }
            });
        }else{
            alert(cupAlertMessage)
        }
    }
    render() {
        const { contentLoading, randomReading,cup_no1,cup_no2,cup_no3,cup_no4 } = this.state;
        if (contentLoading) {
            return <Loader />
        }
        return (
            <div className="coffeereading">
                <div className="coffeereading-box">
                    <div className="coffee-item coffee-headeing">
                        <div className="coffeereading-btn-section">
                            <Link to="/"><img src={require('./../../../assets/images/back-button.png')} className="back-button" /></Link>
                        </div>
                        <div className="heading-title">
                            <h1>
                                <FormattedMessage id="coffeereading.title"
                                    defaultMessage="Coffee Reading"
                                    description=""
                                    values={{}} />
                            </h1>
                        </div>
                    </div>
                    <div className="coffee-item">
                        <p className="daily-coffee text-bold text-color big">
                            <FormattedMessage id="coffeereading.subtitle"
                                defaultMessage="Daily coffee reading"
                                description=""
                                values={{}} />
                        </p>
                        <p>
                            <FormattedMessage id="coffeereading.paragraph"
                                defaultMessage="Coffee Cup Reading is a divination or fortune-telling method that interprets patterns in coffee grounds. To get your reading, click on 3 coffee cups and enjoy your free Coffee Cup Reading."
                                description=""
                                values={{}} />
                        </p>
                    </div>
                    <div className="cofee-cups">
                        <div className="coffee-cups-rows">
                            <img onClick={()=>this.handlSelected(1)} src={require('../../../assets/images/A.png')} className={cup_no1 ? "selected-cup": "cofee-cups-img"}/>
                            <img onClick={()=>this.handlSelected(2)} src={require('../../../assets/images/B.png')} className={cup_no2 ? "selected-cup":"cofee-cups-img"}/>
                        </div>  
                        <div className="coffee-cups-rows">  
                            <img onClick={()=>this.handlSelected(3)} src={require('../../../assets/images/C.png')} className={cup_no3 ? "selected-cup":"cofee-cups-img"}/>
                            <img onClick={()=>this.handlSelected(4)} src={require('../../../assets/images/D.png')} className={cup_no4 ? "selected-cup":"cofee-cups-img"}/>
                        </div>
                    </div>
                    <div className="coffeereading-btn-section">
                            <Button onClick={this.handleDailyreading} className="coffeereading-btn">
                                <FormattedMessage id="coffeereading.button"
                                    defaultMessage="Get Your reading"
                                    description=""
                                    values={{}} />
                            </Button>
                        </div>

                </div>
            </div>
        )
    }
}

export default coffeeCups;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/coffeecupreading/coffeeCups.js